import React from 'react';
import { Sparkles } from 'lucide-react';

const prompts = [
  'Explain my weak skills',
  'What should I focus on next?',
  'How do I improve readiness?',
  'Help me prepare for interviews',
];

const SuggestedPrompts = ({ onSelect }) => (
  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
    {prompts.map((prompt) => (
      <button
        key={prompt}
        type="button"
        onClick={() => onSelect(prompt)}
        className="flex items-center gap-2 rounded-md border border-white/10 bg-white/5 px-3 py-2 text-left text-xs text-purple-100 transition hover:-translate-y-0.5 hover:border-fuchsia-300/50 hover:bg-white/10"
      >
        <Sparkles size={14} aria-hidden="true" />
        <span>{prompt}</span>
      </button>
    ))}
  </div>
);

export default SuggestedPrompts;
